export enum EUserRole {

  Admin = 'admin', // pode tudo
  ManageGroup = 'manage_group', // gerencia o seu grupo de contas e vendedores
  ManageAccount = 'manage_account', // gerencia vendedores da sua conta
  Seller = 'seller' // não tem acesso ao painel

}